import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import BACKEND_URL from "../config/config";
import Maintenance from "../pages/system/Maintenance";

const PUBLIC_EVENT_PATHS = new Set([
  "/",
  "/registration",
  "/emission",
  "/questions",
  "/summary",
  "/success",
  "/failure",
  "/pending",
  "/checkin",
  "/thanks",
  "/thanks-mp",
]);

const PublicMaintenanceGate = ({ children }) => {
  const location = useLocation();
  const [maintenanceActive, setMaintenanceActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const shouldCheckMaintenance = useMemo(
    () => PUBLIC_EVENT_PATHS.has(location.pathname),
    [location.pathname]
  );

  useEffect(() => {
    if (!shouldCheckMaintenance) {
      setMaintenanceActive(false);
      setLoading(false);
      return;
    }

    let cancelled = false;

    const loadPublicConfig = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${BACKEND_URL}/public-config`);
        if (!res.ok) throw new Error("No se pudo cargar public-config");

        const data = await res.json();
        if (!cancelled) {
          setMaintenanceActive(data?.maintenance_page_active === true);
        }
      } catch (error) {
        console.error("Error cargando public-config:", error);
        if (!cancelled) setMaintenanceActive(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadPublicConfig();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, shouldCheckMaintenance]);

  if (shouldCheckMaintenance && loading) return null;
  if (shouldCheckMaintenance && maintenanceActive) return <Maintenance />;

  return children;
};

export default PublicMaintenanceGate;


